import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import { ToastProvider } from "./contexts/ToastContext";
import { store } from "./store";
import "./styles/index.css";
import "./styles/tailwind.css";

const container = document.getElementById("root");

if (!container) {
	throw new Error("Root container with id 'root' not found.");
}

const root = createRoot(container);

try {
	root.render(
		<Provider store={store}>
			<ToastProvider>
				<App />
			</ToastProvider>
		</Provider>,
	);
} catch (error) {
	console.error("[App] Error rendering React app:", error);
	throw error;
}
